import { render } from "./LogSoftwareComponent.vue?vue&type=template&id=335206d3&scoped=true"
import script from "./LogSoftwareComponent.vue?vue&type=script&lang=js"
export * from "./LogSoftwareComponent.vue?vue&type=script&lang=js"

import "./LogSoftwareComponent.vue?vue&type=style&index=0&id=335206d3&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335206d3"]])

export default __exports__